var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2204",
    "data-name": "Rettangolo 2204",
    width: 24,
    height: 24,
    transform: "translate(0.753 0.25)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2251",
    "data-name": "Raggruppa 2251",
    transform: "translate(-0.753 -0.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3606",
    "data-name": "Tracciato 3606",
    d: "M4.5,2.5H21a2.938,2.938,0,0,1,3,3V19a2.938,2.938,0,0,1-3,3H4.5a2.938,2.938,0,0,1-3-3V5.5A2.938,2.938,0,0,1,4.5,2.5Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3607",
    "data-name": "Tracciato 3607",
    d: "M10.5,7h-3A1.5,1.5,0,0,0,6,8.5v3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3608",
    "data-name": "Tracciato 3608",
    d: "M19.5,13v3A1.5,1.5,0,0,1,18,17.5H15",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIcon);
export default __webpack_public_path__ + "static/media/format-icon.fe4a756f1da48e643c0d10b50ee7e3ca.svg";
export { ForwardRef as ReactComponent };